import React, { FunctionComponent } from 'react'
import { SVGProps } from 'interfaces'

const SVG: FunctionComponent<SVGProps> = ({ className }) => (
    <svg width='100%' className={className} viewBox='0 0 70 70' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M58.3335 8.75H11.6668C8.44517 8.75 5.8335 11.3617 5.8335 14.5833V55.4167C5.8335 58.6383 8.44517 61.25 11.6668 61.25H58.3335C61.5552 61.25 64.1668 58.6383 64.1668 55.4167V14.5833C64.1668 11.3617 61.5552 8.75 58.3335 8.75Z'
            fill='#0D1537'
        />
        <path
            d='M29.0168 38.8391C28.6198 40.0301 27.5053 40.8334 26.2498 40.8334H14.5832C12.9723 40.8334 11.6665 39.5276 11.6665 37.9168C11.6665 36.3059 12.9723 35.0001 14.5832 35.0001H24.1476L29.3162 19.4944C30.2389 16.7262 34.205 16.8785 34.9128 19.7094L40.2921 41.227L42.5994 36.6124C43.0935 35.6243 44.1034 35.0001 45.2082 35.0001H55.4165C57.0273 35.0001 58.3332 36.3059 58.3332 37.9168C58.3332 39.5276 57.0273 40.8334 55.4165 40.8334H47.0108L41.9836 50.8878C40.7726 53.3098 37.202 52.9178 36.5453 50.2908L31.6828 30.8411L29.0168 38.8391Z'
            fill='#52BD95'
        />
        <path
            opacity='0.3'
            d='M55.4167 20.4167C57.0275 20.4167 58.3333 19.1109 58.3333 17.5C58.3333 15.8892 57.0275 14.5834 55.4167 14.5834C53.8058 14.5834 52.5 15.8892 52.5 17.5C52.5 19.1109 53.8058 20.4167 55.4167 20.4167Z'
            fill='#BAE5D5'
        />
    </svg>
)

export default SVG
